import React from 'react';

import { getParentLabel, getParentPath } from 'bundles/crm/parent_helpers';

import type { Activity } from 'bundles/apex/activities/types';
import type { Parent, ParentOption } from 'bundles/crm/types';

interface Props {
  activity: Activity;
  asLink?: boolean;
  currentParent?: Parent | Parent[];
  options?: {
    parents?: ParentOption[];
  }
}

export default function ActivityParent({ activity, asLink, currentParent, options }: Props) {
  const label = getParentLabel(activity, { currentParent, parentOptions: options?.parents });
  const path = asLink ? getParentPath(activity, { currentParent }) : null;

  return (
    <div className="text-muted text-xs">
      {path ? <a href={path}>{label}</a> : label}
    </div>
  );
}
